/**
 * useSearchSort
 */

import { useCallback } from 'react';
import _get from 'lodash/get';

import useMediaConfigSearch from 'bdvp-common/src/hooks/config/useMediaConfigSearch';
import {
    Queries,
    ApolloLib,
    Mutations,
} from 'bdvp-graphql';

import useSearchQueryParam from './useSearchQueryParam';

const {
    useApolloClient,
    useMutation,
    useQuery,
} = ApolloLib;

const {
    GET_SELECTED_FILTERS,
    GET_SEARCH_SORT,
    GET_IS_SORTING,
} = Queries;

const { SET_SEARCH_SORT, SET_IS_SORTING } = Mutations;

const useSearchSort = () => {

    const client = useApolloClient();
    const { sortOptions: searchSortOptions = [] } = useMediaConfigSearch();
    const { updateSearchQuery } = useSearchQueryParam();

    const { data } = useQuery(GET_SEARCH_SORT);
    const { searchSort } = data || {};
    const searchSortSelectedOption = searchSortOptions.filter((searchSortOption) => {

        return searchSortOption.value === searchSort;

    })[0] || null;

    const { data: sortingData } = useQuery(GET_IS_SORTING);
    const isSorting = sortingData?.isSorting || false;

    const [setIsSortingMutation] = useMutation(SET_IS_SORTING);
    const [setSearchSortMutation] = useMutation(SET_SEARCH_SORT);
    const [applySearchSortMutation] = useMutation(
        SET_SEARCH_SORT,
        {
            onCompleted: () => {

                const { selectedFilters } = client.readQuery({ query: GET_SELECTED_FILTERS });
                updateSearchQuery(selectedFilters);
                setIsSorting(true);

            },
        }
    );

    const setSearchSort = useCallback(
        (searchSort) => (
            setSearchSortMutation({
                variables: {
                    searchSort,
                },
            })
        ),
        [setSearchSortMutation]
    );

    const applySearchSort = useCallback(
        (searchSort) => (
            applySearchSortMutation({
                variables: {
                    searchSort,
                },
            })
        ),
        [applySearchSortMutation]
    );

    const setIsSorting = useCallback(
        (isSorting) => (
            setIsSortingMutation({
                variables: {
                    isSorting: isSorting,
                },
            })
        ),
        [setIsSortingMutation]
    );

    return {
        searchSortOptions,
        searchSortSelectedOption,
        applySearchSort,
        setSearchSort,
        isSorting,
        setIsSorting,
    };

};

export default useSearchSort;
